module.exports = __webpack_public_path__ + "static/media/tools-zoom-mode-next.7b241b37.svg";